export default "__VITE_ASSET__adab8544__"